import { render, staticRenderFns } from "./Paperwork.vue?vue&type=template&id=9e499354&"
import script from "./Paperwork.vue?vue&type=script&lang=js&"
export * from "./Paperwork.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports